/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_LithuanianInputs */



/**
* | output |
* | --- |
* | "Lithuanian" |
*
* @param {Speechmatics_Target_Language_LithuanianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_lithuanian = /** @type {((inputs?: Speechmatics_Target_Language_LithuanianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_LithuanianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lituanien")
	if (locale === "de") return /** @type {LocalizedString} */ ("litauisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("lituano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("литовский")
	if (locale === "es") return /** @type {LocalizedString} */ ("lituano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("立陶宛语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リトアニア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिथुआनियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("lituano")
	return /** @type {LocalizedString} */ ("Lithuanian")
});